import React from 'react';
import { Progress } from '@nackle/paper';
import { LocaleString, getString } from '@nackle/intl-tools';
import './budget-meter.less';

const BudgetMeter = ( { percent, current, totalAward, originalBudget, additionalInfo } ) => {
    return (
        <div className='budget-meter-container'>
            {
                <div className='header-text'>
                    <LocaleString code="recognition.budget.awarded" replaceOptions={ { points: totalAward, mediaLabel: getString( 'mediaLabel' ) } } />
                </div>
            }
            <Progress
                percent={ percent }
                status="active"
                strokeColor={ current < 0 ? '#FDE7E9' : '#3F8CFF' }
                showInfo={ false }
            />
            <div className='footer-container'>
                <div className={ current < 0 ? 'error-text primary-footer-text' : 'primary-footer-text' }>
                    <LocaleString code="recognition.budget.available" replaceOptions={ { points: originalBudget, mediaLabel: getString( 'mediaLabel' ) } } />
                    { ' · ' }
                    { additionalInfo ?
                        <span className='secondary-footer-text'>{ additionalInfo }</span>
                        :
                        <LocaleString code="recognition.budget.remaining" replaceOptions={ { points: current, mediaLabel: getString( 'mediaLabel' ) } } />
                    }
                </div>
            </div>
        </div>
    );
};

export default BudgetMeter;
